"use strict";
module.exports = {
    SHOP_USER_UPDATED: 'Kundinlogg uppdaterad',
    SHOP_USER_CREATED: 'Kundinlogg skapdes',
    SHOP_USER_PREFERRED_CUSTOMER_SUB_UNIT_UPDATED: 'Föredragen kundinlogg uppdaterad',
    SHOP_USER_APPROVED: 'Kundinlogg godkänt',
    SHOP_USER_DISAPPROVED: 'Kundinlogg icke godkänt',
    SHOP_USER_ACTIVATED: 'Kundkonto aktiverat',
    SHOP_USER_DEACTIVATED: 'Kundkonto inaktiverat',
    SHOP_USER_EMAIL_VERIFIED: 'Kundens epost verifierad',
    SHOP_USER_SENT_FORGOT_PASSWORD_LINK: 'Skickat lösenordsåterställningsmail',
    SHOP_USER_PASSWORD_CHANGED: 'Bytt lösenord',
    SHOP_USER_SUPPLIER_CUSTOMER_CHANGED: 'Bytt vilken kund inloggningen är kopplad till',
    INVITE_UPDATED: 'Skickat påminnelse om inbjudan',
    INVITE_CREATED: 'Skickat inbjudan',
    END_CUSTOMER_ORGANIZATION_UPDATED: 'END_CUSTOMER_ORGANIZATION_UPDATED',
    END_CUSTOMER_ORGANIZATION_CREATED: 'END_CUSTOMER_ORGANIZATION_CREATED',
};
